export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        description: entity.description || '',
        funder: entity.funder || undefined,
        type: entity.type || { financialType: undefined, value: 0 },
        activation: entity.activation || undefined,
        validAt: entity.validAt || { restaurants: [] }
    };
};